import React from "react";
import './About.css';
import { useTranslation } from 'react-i18next';


const About = ({ aboutData }) => {
  const { t } = useTranslation();

  if (!aboutData || !Array.isArray(aboutData) || aboutData.length === 0) {
    return (
      <section className="about-section" id="about">
        <h2>{t('about.title')} </h2>
        <p>{t('messages.loading')} </p>
      </section>
    );
  }

  const aboutItem = aboutData[0];

  const listItemsArray = aboutItem && aboutItem.list_item
    ? aboutItem.list_item.split(';').map(item => item.trim())
    : [];

  return (
    <section className="about-section" id="about">

      <h2>{t('about.title')}</h2>

      {aboutItem.image_url && (
        <img src={aboutItem.image_url} alt={t('about.imageAlt')} width="200" height="auto" className="about-image" loading="lazy" />

      )}

      {aboutItem.title && <h3 className="about-db-title">{aboutItem.title}</h3>}

      {aboutItem.paragraph && (
        <div className="about-paragraph">
          {aboutItem.paragraph.split(/\r\n|\r|\n/).map((line, index) => (

            line.trim() ? <p key={index}>{line.trim()}</p> : null
          ))}
        </div>
      )}

      {listItemsArray.length > 0 && (
        <div className="about-skills-list">
          <h4>{t('about.skillsListTitle')}</h4>
          <ul>
            {listItemsArray.map((skill, index) => (
              <li key={index}>{skill}</li>
            ))}
          </ul>
        </div>
      )}
    </section>
  );
};

export default About;
